// extracted by mini-css-extract-plugin
module.exports = {"modal":"ErrorModal_modal__3QiLw","icon":"ErrorModal_icon__3cRep","body":"ErrorModal_body__2Bfja","button":"ErrorModal_button__2I0TT"};